import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createBlock(_component_Button, {
    onOnClick: _ctx.claimBet,
    color: _ctx.color,
    text: "Claim"
  }, null, 8, ["onOnClick", "color"]))
}